export default "__VITE_ASSET__BRc35zMi__"